import styled, { css } from 'styled-components'
import { TypeFiesta } from '@at/design-system-foundation'

export const ZeroResultsBannerWrapperModal = styled(TypeFiesta)`
    ${({ theme }) => css`
        background-color: ${theme.color.bgFill.highlight};
        border: 1px solid ${theme.color.border.info};
        border-radius: 4px;
        padding: 24px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 auto 20px auto;
        text-align: center;
        gap: 32px;
        width: 100%;
        max-width: 596px;
    `}
`

export const ZeroResultsBannerWrapper = styled(TypeFiesta)`
    ${({ theme }) => css`
        color: ${theme.color.text.title};
        padding: 24px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 auto 20px auto;
        text-align: center;
        gap: 32px;
        width: 100%;
        max-width: 596px;
    `}
`
